var map = {
	"./light_0.png": "bb41",
	"./light_0_0.png": "7015",
	"./light_0_1.png": "0ae5",
	"./light_1.png": "82d2",
	"./light_1_0.png": "a5df",
	"./light_1_1.png": "6765",
	"./light_dg_0.png": "ebff",
	"./light_dg_1.png": "35d4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9f61";